import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, GiftIcon, PiggyBankIcon, SparklesIcon } from 'lucide-react';
import { BONOS } from '../data/landing';
import { CtaButton } from './CtaButton';
export function SavingsSection() {
  return <section className="w-full overflow-hidden bg-green-700 py-10 text-white sm:py-16" data-id="element-185" data-mp="2kzoxmz5v1i0x">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-186" data-mp="2g62ohgywnw9v">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.1fr]" data-id="element-187" data-mp="2tyiwkw6nykhn">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45
        }} data-id="element-188" data-mp="2ozz9utk8x4o8">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase tracking-wide text-neutral-900" data-id="element-189" data-mp="2yz6p5majj9dz">
              <PiggyBankIcon className="h-4 w-4" data-id="element-190" data-mp="14kdtjn9nqim1" /> Tu ahorro de hoy
            </span>
            <h2 className="mt-4 text-3xl font-black leading-[1.05] tracking-tight sm:text-4xl" data-id="element-191" data-mp="14mgu318fru50">
              Te estás ahorrando <span className="text-yellow-300" data-id="element-192" data-mp="2vjp8py5esjpa">$81.500</span> solo en
              bonos.
            </h2>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-green-50 sm:text-lg" data-id="element-193" data-mp="30ijrj03dm89e">
              No pagás un peso extra por ninguno de estos complementos. Los 5 se suman al
              MegaPack <strong className="text-white" data-id="element-194" data-mp="3a94wd59n890r">sin cargo solamente hoy</strong>.
            </p>

            <div className="mt-6 rounded-2xl border border-green-500 bg-green-800/70 p-5" data-id="element-195" data-mp="3f7po0gatxkdl">
              <div className="flex items-center justify-between gap-4" data-id="element-196" data-mp="3j9jkecdzs27y">
                <span className="text-sm font-semibold text-green-100" data-id="element-197" data-mp="3jacn929ty7kt">Valor de los 5 bonos</span>
                <span className="text-xl font-black text-white line-through" data-id="element-198" data-mp="3o7utum0dkapn">$81.500</span>
              </div>
              <div className="my-4 h-px bg-green-500" data-id="element-199" data-mp="1oxmmq1oyi04g" />
              <div className="flex items-center justify-between gap-4" data-id="element-200" data-mp="1tvo66nqao1gg">
                <span className="flex items-center gap-2 text-base font-bold text-white" data-id="element-201" data-mp="2x596t94c2pz1">
                  <GiftIcon className="h-5 w-5 text-yellow-300" data-id="element-202" data-mp="2s6pfet6z0lza" /> Lo que pagás hoy por ellos
                </span>
                <span className="text-3xl font-black text-yellow-300" data-id="element-203" data-mp="366qi8e6sq3he">$0</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: 0.08
        }} className="rounded-3xl bg-white p-5 text-neutral-900 shadow-2xl sm:p-7" data-id="element-204" data-mp="315kocd1ega6a">
            <div className="flex items-center gap-2 border-b border-neutral-100 pb-4" data-id="element-205" data-mp="3kv3elc9spocf">
              <SparklesIcon className="h-5 w-5 text-yellow-500" data-id="element-206" data-mp="3kxh8viwniwix" />
              <p className="text-sm font-black uppercase tracking-wide text-neutral-700" data-id="element-207" data-mp="2q9ut1txivbd">
                El ahorro, peso por peso
              </p>
            </div>
            <ul className="mt-2 divide-y divide-neutral-100" data-id="element-208" data-mp="hbnu1dty2ive">
              {BONOS.map(bono => <li key={bono.numero} className="flex items-center justify-between gap-4 py-3" data-id="element-209" data-mp="mba7nodoq14q">
                  <span className="flex items-center gap-2 text-sm font-semibold text-neutral-700" data-id="element-210" data-mp="7e19obtvlz41">
                    <BadgeCheckIcon className="h-4 w-4 shrink-0 text-green-600" data-id="element-211" data-mp="cd46xa3m711g" />
                    <span data-id="element-212" data-mp="cexc0kykxd7c">
                      {bono.numero}{' '}
                      <span className="hidden sm:inline" data-id="element-213" data-mp="3upiro8255jla">— {bono.titulo}</span>
                    </span>
                  </span>
                  <span className="shrink-0 text-sm font-bold text-neutral-400 line-through" data-id="element-214" data-mp="3e8yrsh0fgvi">{bono.valor}</span>
                </li>)}
            </ul>
            <div className="mt-3 rounded-xl bg-yellow-100 px-4 py-4 text-center" data-id="element-215" data-mp="3pt235cr1537o">
              <p className="text-lg font-black uppercase leading-tight tracking-tight text-neutral-900 sm:text-xl" data-id="element-216" data-mp="3brpp56vfjbof">
                Te llevás todo esto hoy por <span className="text-green-700" data-id="element-217" data-mp="3ft1gphxv66z9">$0 pesos gratis</span>
              </p>
            </div>
          </motion.div>
        </div>

        
      </div>
    </section>;
}